import { render, staticRenderFns } from "./noSummary.vue?vue&type=template&id=6f6724a3&scoped=true"
import script from "./noSummary.vue?vue&type=script&lang=js"
export * from "./noSummary.vue?vue&type=script&lang=js"
import style0 from "./noSummary.vue?vue&type=style&index=0&id=6f6724a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6724a3",
  null
  
)

export default component.exports